import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';
import YumurtlamaImg from '../../assets/yumurtlama.jpeg';
import AsrmEshre from '../../components/asrmEshre';
import AudioPlayer from '../../components/audioPlayer';

export function Yumurtlama() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="yumurtlamanın uyarılması" /></h1>
          <h2 className="subtitle"><TranslateStatic string="yumurtlamanın uyarılması2" /></h2>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="yumurtlamanın uyarılması" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="Yumurtlama" />
          </div>

          <div className="audio-container">
            <AudioPlayer src="/sesler/yumurtalıkların_uyarilmasi.mp3" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <p>
              <TranslateStatic string="yumurtlamaUsP1" />
            </p>
            <h3><TranslateStatic string="yumurtlamaUsh3-1" /></h3>
            <p>
              <TranslateStatic string="yumurtlamaUsP2" />
            </p>
            <p>
              <TranslateStatic string="yumurtlamaUsP2-1" />
            </p>
            <p>
              <TranslateStatic string="yumurtlamaUsP2-2" />
            </p>
            <h3><TranslateStatic string="yumurtlamaUsh3-2" /></h3>
            <p>
              <TranslateStatic string="yumurtlamaUsP3" />
            </p>
            <p>
              <TranslateStatic string="yumurtlamaUsP3-1" />
            </p>
            <p>
              <TranslateStatic string="yumurtlamaUsP3-2" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
